import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-homeone-process',
    templateUrl: './homeone-process.component.html',
    styleUrls: ['./homeone-process.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeoneProcessComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: "How It's Work",
            title: 'Our Process',
            paragraphText: 'From initial consultation to continuous support, we ensure a seamless integration of top-tier IT professionals into your team, driving your projects towards success.'
        }
    ]
    singleProcessBox: processBoxContent[] = [
        {
            img: 'assets/img/process/img1.png',
            title: 'Conceptualization',
            paragraphText: 'Our team will enhance your idea through comprehensive analysis and market research.',
            number: '1'
        },
        {
            img: 'assets/img/process/img2.png',
            title: 'Design & Development',
            paragraphText: 'Our skilled designers and developers will craft a visually appealing and high-performing app using the latest technology stack',
            number: '2'
        },
        {
            img: 'assets/img/process/img3.png',
            title: 'Deployment & Iteration',
            paragraphText: 'The app will be launched after client approval, with future updates and features cycling back to the initial planning phase.',
            number: '3'
        },
        // {
        //     img: 'assets/img/process/img4.png',
        //     title: 'Explore the Data',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
        //     number: '4'
        // },
        // {
        //     img: 'assets/img/process/img5.png',
        //     title: 'Perform In-depth Analysis',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
        //     number: '5'
        // },
        // {
        //     img: 'assets/img/process/img6.png',
        //     title: 'Communicate Results',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
        //     number: '6'
        // }
    ]

}
class sectionTitleContent {
    subTitle : string;
    title : string;
    paragraphText : string;
}
class processBoxContent {
    img : string;
    title : string;
    paragraphText : string;
    number : string;
}